import { encodeBase64, decodeBase64 } from "src/utils";

// Obfuscated base64 string encoding and decoding
const encode = string => "=" + encodeBase64(string);
const decode = string => decodeBase64(string.substring(1));

// The global Storage object
const Storage = {
  get: key => {
    const value = localStorage.getItem(`af-${key}`);
    return value && JSON.parse(decode(value));
  },
  set: (key, value) => {
    const val = JSON.stringify(value);
    localStorage.setItem(`af-${key}`, encode(val));
  }
};

export default Storage;

// Expose hook in dev/staging
window.Storage = GLOBALS.ENV !== "production" && Storage;
